export const PDP_PAGE_LOAD_READY = 'PDP_PAGE_LOAD_READY';
export const PDP_CART_ADD_ANALYTICS = 'PDP_CART_ADD_ANALYTICS';
export const PDP_CART_UPDATE_ANALYTICS = 'PDP_CART_UPDATE_ANALYTICS';
export const PDP_REGISTRY_ADD_ANALYTICS = 'PDP_REGISTRY_ADD_ANALYTICS';
export const PDP_TOOL_CLICK_ANALYTICS = 'PDP_TOOL_CLICK_ANALYTICS';
export const PDP_SAMEDAY_PICKUP_ANALYTICS = 'PDP_SAMEDAY_PICKUP_ANALYTICS';
export const PDP_CHECK_AVAILABILITY_ANALYTICS = 'PDP_CHECK_AVAILABILITY_ANALYTICS';
export const PDP_OPEN_MODAL_ANALYTICS = 'PDP_OPEN_MODAL_ANALYTICS';
export const PDP_CHANGE_ZIPCODE_ANALYTICS = 'PDP_CHANGE_ZIPCODE_ANALYTICS';
export const PDP_VIDEO_PLAYER_ANALYTICS = 'PDP_VIDEO_PLAYER_ANALYTICS';
export const PDP_PRODUCT_OOS_ANALYTICS = 'PDP_PRODUCT_OOS_ANALYTICS';
export const PDP_CARE_PLAN_VIEW_ANALYTICS = 'PDP_CARE_PLAN_VIEW_ANALYTICS';
export const PDP_FORM_ERROR_ANALYTICS = 'PDP_FORM_ERROR_ANALYTICS';
export const PDP_CARE_PLAN_ACCEPT_ANALYTICS = 'PDP_CARE_PLAN_ACCEPT_ANALYTICS';
export const PDP_PAGE_LOAD_READY_SUCCESS = 'PDP_PAGE_LOAD_READY_SUCCESS';
export const SEARCH_STORES_CLICK_EVENT = 'SEARCH_STORES_CLICK_EVENT';
export const PDP_PAGE_LOAD_READY_ONRESET = 'PDP_PAGE_LOAD_READY_ONRESET';
export const BUNDLE_PDP_CART_ADD_ANALYTICS = 'BUNDLE_PDP_CART_ADD_ANALYTICS';
export const SELECT_OPTIONS_ANALYTICS = 'SELECT_OPTIONS_ANALYTICS';
export const PDP_ATC_CLICK_EVENT = 'PDP_ATC_CLICK_EVENT';
export const PDP_SHOP_THE_LOOK_READY = 'PDP_SHOP_THE_LOOK_READY';
export const PDP_SHOP_THIS_LOOK_CLICK_EVENT = 'PDP_SHOP_THIS_LOOK_CLICK_EVENT';
export const PDP_SHOP_THE_LOOK_MINI_PDP_CLICK_EVENT = 'PDP_SHOP_THE_LOOK_MINI_PDP_CLICK_EVENT';
export const PDP_ENABLE_VTO = 'PDP_ENABLE_VTO';
export const PDP_SHOP_THE_COLLECTION_READY = 'PDP_SHOP_THE_COLLECTION_READY';
export const PDP_PAGE_LOAD_PRODUCT_OOS = 'PDP_PAGE_LOAD_PRODUCT_OOS';
export const PDP_SHOP_THE_SET_READY = 'PDP_SHOP_THE_SET_READY';
export const PDP_SHOP_THE_SET_CLICK_EVENT = 'PDP_SHOP_THE_SET_CLICK_EVENT';
export const PDP_PSC_AVAILABILITY = 'PDP_PSC_AVAILABILITY';
